import {
  formatWakeLoopCliLine,
  formatWakeLoopCliTextBlock,
} from "./cli-entry-command";
import type { DualViewGuideInput } from "./dual-view-guide";

export function formatDualViewGuideForDisplay(
  input: DualViewGuideInput
): DualViewGuideInput {
  return {
    summary: formatWakeLoopCliTextBlock(input.summary),
    humanSteps: input.humanSteps.map((item) => formatWakeLoopCliLine(item)),
    ...(input.agentRequiredArgs
      ? {
          agentRequiredArgs: input.agentRequiredArgs.map((item) =>
            formatWakeLoopCliLine(item)
          ),
        }
      : {}),
    ...(input.agentOptionalArgs
      ? {
          agentOptionalArgs: input.agentOptionalArgs.map((item) =>
            formatWakeLoopCliLine(item)
          ),
        }
      : {}),
    ...(input.agentCommands
      ? {
          agentCommands: input.agentCommands.map((item) =>
            formatWakeLoopCliLine(item)
          ),
        }
      : {}),
    ...(input.notes
      ? {
          notes: input.notes.map((item) => formatWakeLoopCliTextBlock(item)),
        }
      : {}),
  };
}
